import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from './Header';
import { Footer } from './Footer';
import { StickyMobileCta } from '../StickyMobileCta';
import { ScrollToHash } from './ScrollToHash';
import { RoutedPageFallback } from './RoutedPageFallback';
import { cn } from '../../lib/utils';
import { LunaSupportChat } from '../LunaSupportChat';

const MAIN_CONTENT_ID = 'main-content';

export function Layout(): React.JSX.Element {
  const { t } = useTranslation('common');
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div
      id="top"
      tabIndex={-1}
      className={cn(
        'flex min-h-screen flex-col outline-none',
        isHomePage && 'site-shell--home'
      )}
    >
      <a
        href={`#${MAIN_CONTENT_ID}`}
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-[var(--ir-deep)] focus:px-5 focus:py-3 focus:text-sm focus:font-bold focus:text-white"
      >
        {t('nav.skipToContent')}
      </a>
      <ScrollToHash />
      <Header />
      <main id={MAIN_CONTENT_ID} tabIndex={-1} className="flex-1 outline-none">
        <Suspense fallback={<RoutedPageFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <StickyMobileCta />
      <LunaSupportChat />
    </div>
  );
}
